import { type DisplayRole, deriveDisplayRole } from "@unbox/api";
import type { TeamRow } from "./team-table";

export type TeamSortColumn = "name" | "role" | "status";
export type TeamSort = { column: TeamSortColumn; direction: "asc" | "desc" };

/** Ascending puts the widest access first, so the admins lead the list. */
const ROLE_ORDER: DisplayRole[] = ["workspace_admin", "merchant_admin", "multiple", "user"];

const statusRank = (row: TeamRow) => (row.kind === "member" ? 0 : row.expired ? 2 : 1);

const nameOf = (row: TeamRow) => (row.kind === "member" && row.name ? row.name : row.email);

const byName = (a: TeamRow, b: TeamRow) => nameOf(a).localeCompare(nameOf(b));

const COMPARE: Record<TeamSortColumn, (a: TeamRow, b: TeamRow) => number> = {
  name: byName,
  role: (a, b) => ROLE_ORDER.indexOf(deriveDisplayRole(a.roles)) - ROLE_ORDER.indexOf(deriveDisplayRole(b.roles)),
  status: (a, b) => statusRank(a) - statusRank(b),
};

/** Rows that tie on the sorted column stay in name order whichever way it runs. */
export const sortTeamRows = (rows: TeamRow[], { column, direction }: TeamSort): TeamRow[] =>
  [...rows].sort((a, b) => {
    const compared = COMPARE[column](a, b);
    if (compared !== 0) return direction === "asc" ? compared : -compared;
    return byName(a, b);
  });
